import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  button: {
    padding: spacing(6),
  },
  secondButton: {
    padding: spacing(6, 12.5),
  },
  icon: {
    scale: '0.75',
    stroke: Theme.Colors.Primary.Base,
    marginRight: spacing(6),
  },
}))
